import React from 'react';
import NavBar from '../navbar/NavBar';
import traslatorImage from '../../../medias/images/heroTop-translator.png'
import traslatorImg from '../../../medias/images/herotop-translation.svg'
import { GiCottonFlower } from 'react-icons/gi';
import Container from '../../utils/Container'
import Heading1 from '../../elements/titles/Heading1'
import LoadImage from '../../elements/images/LoadImage'

import Button from '../../elements/buttons/Button'
import ButtonHead from '../../elements/buttons/ButtonHead'

function HeroTopHome(props) {
    return (
        <header className=" w-full h-screen md:h-auto " id="herotopHome">
            <NavBar classe="hidden md:block" />
            <div className="hero-div w-full h-full md:py-20 ">
                <NavBar classe="md:hidden" />
                <Container>
                    <div className='content-div flex justify-center items-center mt-24 md:mt-0'>

                        <div className="flex-none w-auto hidden lg:block w-full h-full">
                            <LoadImage 
                                img={ traslatorImg }
                                classe='traslatorImg  w-2/5 h-auto'
                                alt="Rita nsangou traductrice anglais, français et espagnol"
                                title='Rita nsangou spécialiste en traduction des langues'
                            />
                        </div>

                        <div className="md:ml-5 text-center md:text-left  xl:ml-15 lg:ml-5 xl:ml-14">
                            <Heading1
                                size="big"
                                classe="main-hero-text mt-3 mb-4"> 
                              <span className="sm:block lg:inline">Traductrice des langues, </span> 
                              <span>indépendante</span>
                            </Heading1>

                            <p className='text-base hero-description lg:text-lg text-center md:text-left font-nunito font-light opacity-50 md:w-96'>
                              Je vous aide à communiquer plus simplement en traduisant <br className="hidden sm:inline-block md:hidden" /> vos textes et documents
                              <span className="hidden lg:inline lg:invisible text-center md:text-left ">dans les langues les plus parlés</span>
                            </p>

                            <Button
                                link="/contact"
                                size="big"
                                classe="hero-btn mt-6 md:mt-3"
                            >
                                Démander un devis
                            </Button>
                        </div>
                    </div>      
                </Container>
            </div>
        </header>
    );
}

export default HeroTopHome;